module.exports = __webpack_public_path__ + "img/2.e3efb006.jpg";